<template>
    <div class="card">
        <div class="top">
            <span class="bold name">{{salon.name}}</span>
        </div>
        <div class="bottom">
            <div class="left">
                <div class="sid"><span class="bold">{{$t('general.salonID')}}: </span> {{salon.sid}}</div>
                <div><span class="bold">{{$t('general.city')}}: </span> {{salon.city}}, {{salon.address}}</div>
                <!--                <div><span class="bold">Województwo: </span> Kujawsko-pomorskie</div>-->
                <div class="count"><span
                        class="bold">{{$t('general.entriesCount')}}: {{salon.ins || 0}}</span>
                </div>
            </div>
            <div class="right"><img :src="require('@/assets/images/localization/marker.png')" @click="showOnMap">
                <button @click="showOnMap">{{$t('general.displayOnMap')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SalonLocalization',
  props: {
    salon: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showOnMap() {
      const coordinates = this.salon.latLng;
      this.$emit('changeMap', coordinates);


      window.scroll({
        top: 200,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    .left {
        text-align: left;
        max-width: 300px;
    }

    .card {
        background: $white;
        border-radius: 5px;
        box-shadow: 0 5px 6px 0 $baseShadow;
        //// color: $baseTextColor;
        font-size: rem(18px);
        width: 48%;
        box-sizing: border-box;
        margin-bottom: 45px;
        @include media('<750px') {
            width: 100%;
        }

        .bold {
            font-weight: 900;
        }

        .top {
            border-bottom: 1px solid #e5e5e5;
            font-size: rem(16px);
            display: flex;
            justify-content: flex-start;

        }

        .bottom {
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            padding-left: 30px;

            .right {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-right: 100px;
                align-self: flex-start;
                margin-top: 30px;

                button {
                    border: none;
                    background: none;
                    color: $peacock-blue;
                }
            }
        }
    }

    .name {
        padding: 15px 30px;
        font-weight: 900;
        text-transform: uppercase;
    }

    .sid {
        margin-bottom: 45px;
        text-transform: uppercase;
    }

    .count {
        margin: 45px 0;
    }

</style>
